<template>
  <keep-alive>
    <div class="d-flex align-center">
      <component
        :is="component"
        v-bind="$props"
        :get-data="responseData"
        @input="$emit('input', $event)"
        @click:clear="$emit('click:clear')"
      >
        <template
          v-if="$scopedSlots.item"
          #item="{ item }"
        >
          <slot
            name="item"
            :item="item"
          />
        </template>
      </component>

      <div class="pt-1 d-flex">
        <component
          :is="dynamicButtonComponent"
          v-if="!readonly"
          :color="errors.length > 0 ? 'error' : 'primary'"
          :disabled="disabled"
          @click.stop="$emit('click:openDialog')"
        >
          <template #tooltip>
            <slot name="tooltip" />
          </template>
        </component>

        <slot name="append-outer-actions" />
      </div>
    </div>
  </keep-alive>
</template>

<script>
// components
import genericPickerProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-props';

export default {
  name: 'GenericPickerWithInputField',
  mixins: [genericPickerProps],
  computed: {
    component() {
      if (this.isFormElement) {
        return 'w-form-autocomplete-lazy';
      }
      return 'w-autocomplete-lazy';
    },
    dynamicButtonComponent() {
      if (this.buttonComponent) {
        return this.buttonComponent;
      }
      return 'w-search-button';
    },
  },
};
</script>
